'use strict';
import EventsEmitter from 'events';

class Channels extends EventsEmitter {}
const channels = new Channels();


export default channels;


// WEBPACK FOOTER //
// ./resources/js/base/channels.js